import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Field, Form, formValueSelector, reduxForm, change } from 'redux-form/immutable';
import renderSelect from '../../../../components/Select/reduxForm';
import { useQuery } from 'react-query';
import RelativeLoading from '../../../../components/Loading/RelativeLoading';
import { renderTextArea } from '../../../../components/Textarea';
import renderDateField from '../../../../components/DateField/reduxFormDateField';
import renderRadioGroup from '../../../../components/RadioGroup/reduxForm';
import Button from '../../../../components/Button';
import Card from '../../../../components/Card';
import * as parsers from '../../../../utils/reduxForm/parsers';
import { selectValueParser } from '../../../../utils/reduxForm/parsers';
import { isRequiredFn } from '../../../Taps/components/NDFL3/services/CommonValidations';
import { useSelector, useDispatch } from 'react-redux';
import { apiResponseWrapper } from '../../../../utils/apiResponseWrapper';
import { surveySupportMeasuresDicts } from './SupportConfirmationService';

const formName = 'QuestionsForm';

function QuestionsForm({ handleSubmit }) {
  const dispatch = useDispatch();
  const { isFetching, data: supportDict } = useQuery('getSupportMeasuresDicts', async () => {
    return apiResponseWrapper(await surveySupportMeasuresDicts());
  });

  const isOther = useSelector((state) => {
    return formValueSelector(formName)(state, 'measurerExecutant') === '1';
  });

  const measurerExecutantCommentValue = useSelector((state) => {
    return formValueSelector(formName)(state, 'measurerExecutantComment');
  });

  useEffect(() => {
    if (!isOther && measurerExecutantCommentValue) {
      dispatch(change(formName, 'measurerExecutantComment', null));
    }
  }, [isOther]);

  return (
    <Form onSubmit={handleSubmit}>
      {isFetching ? (
        <RelativeLoading />
      ) : (
        <div>
          <div className={'H2 pt-3'}>Какие меры поддержки Вам необходимы</div>
          <Card className={'mt-3 mb-3 p-3'}>
            <Field
              validate={isRequiredFn}
              label={'Вид поддержки *'}
              name={'measureDirection'}
              options={supportDict?.measureDirections}
              parse={selectValueParser}
              component={renderSelect}
              isFull
            />
            <Field
              label={'Приоритет *'}
              name={'priority'}
              validate={isRequiredFn}
              options={supportDict?.priorities}
              parse={selectValueParser}
              component={renderSelect}
            />
            <Field
              label={'Проблема, которая решается выбранной мерой поддержки *'}
              name={'problemText'}
              validate={isRequiredFn}
              maxLength={5000}
              component={renderTextArea}
              promtText={'Максимальное количество 5000 знаков'}
            />
            <Field
              validate={isRequiredFn}
              label={'Предлагаемое решение *'}
              name={'solutionText'}
              component={renderTextArea}
              maxLength={5000}
              promtText={'Максимальное количество 5000 знаков'}
            />
            <Field
              validate={isRequiredFn}
              label={'Эффект от реализации меры *'}
              name={'measureEffect'}
              component={renderTextArea}
              maxLength={5000}
              promtText={'Максимальное количество 5000 знаков'}
            />
            <Field
              minDate={new Date()}
              label={'Дата начала *'}
              name={'dateStart'}
              component={renderDateField}
              validate={isRequiredFn}
              parse={parsers.momentParser}
            />
            <Field
              minDate={new Date()}
              parse={parsers.momentParser}
              validate={isRequiredFn}
              label={'Дата окончания *'}
              name={'dateEnd'}
              component={renderDateField}
            />
            <Field
              label={'Кто должен реализовать меру'}
              name={'measurerExecutant'}
              parse={selectValueParser}
              options={supportDict?.measurerExecutants}
              component={renderSelect}
            />
            {isOther && (
              <Field
                label={'Введите исполнителя *'}
                validate={isRequiredFn}
                name={'measurerExecutantComment'}
                component={renderTextArea}
                maxLength={5000}
                promtText={'Максимальное количество 5000 знаков'}
              />
            )}
            <Field
              label={'Вид меры'}
              name={'isFinanceMeasure'}
              isInline
              component={renderRadioGroup}
              parse={parsers.booleanParser}
              items={[
                { label: 'Финансовая', value: true },
                { label: 'Нефинансовая', value: false },
              ]}
            />
            <Button type={'submit'}>Отправить</Button>
          </Card>
        </div>
      )}
    </Form>
  );
}

export default reduxForm({
  form: formName,
  initialValues: {
    isFinanceMeasure: true,
  },
})(QuestionsForm);

QuestionsForm.propTypes = {
  handleSubmit: PropTypes.func,
};
